import React from 'react'
import { FormattedMessage } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import Image from './Image'

interface RevealFieldProps {
  text: string
  image: string
}

const RevealField = ({ text, image }: RevealFieldProps) => {
    const [isHovered, setIsHovered] = React.useState(false)

    return (
        <div
            className='relative group'
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div
                style={{ transform: isHovered ? 'scale(1.1)' : 'scale(1)' }}
                className={twMerge(
                    'aspect-video border border-black rounded-full flex items-center justify-center text-center p-1 md:p-3 relative overflow-hidden transition duration-500 ease-out',
                    isHovered ? 'border-opacity-0' : 'border-opacity-20',
                )}
            >
                <div
                    className={twMerge(
                        'opacity-0 group-hover:opacity-50 w-full h-full absolute transition-all',
                    )}
                >
                    <Image slug={image} alt={text} />
                </div>
            </div>
            <div className='absolute top-1/2 left-1/2 text-center -translate-x-1/2 -translate-y-1/2'>
                <FormattedMessage id={text}>
                    {(value) => <p className='opacity-100 leading-[22.4px]'>{value}</p>}
                </FormattedMessage>
            </div>
        </div>
    )
}

export default RevealField
